import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import {getTheme} from "app/components/ThemeProvider/theme";
import {useMediaQuery} from "@mui/material";

const usePaymentDetails = () => {
  const navigate = useNavigate();
  const [asanConfirmation, setAsanConfirmation] = useState(false);
  const { control, register } = useForm();

  const theme = getTheme('light');

  const largeScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const tabletScreen = useMediaQuery(theme.breakpoints.down(768));
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const options = [
    { value: 'option1', label: 'option1' },
    { value: 'option2', label: 'option2' },
    { value: 'option3', label: 'option3' },
  ];

  const handleBack = () => {
    navigate(-1);
  };

  return {
    options,
    handleBack,
    asanConfirmation,
    setAsanConfirmation,
    control,
    register,
    smallScreen
  };
};

export default usePaymentDetails;
